<div class="lets_take">
  <div class="lets_take_inner">
    <h1>Let’s Take Off Your Study
      Abroad Journey Together !</h1>
    <div class="photo">
      <img src="assets/images/contact_us_new.png" alt="Contact Us">
    </div>
  </div>
</div>

<div class="journey_begins_w">
  <div class="journey_begins_inner" id="contact-form">
    <div class="text">
      <h1>Your journey begins here</h1>
      <div class="text_inner">
        <p>At Gradpilots, we don’t just tell you which country or course to pick – we become your journey partner from
          Day 1 till you land on campus. Whether you’re confused about how your CGPA will impact admissions, stuck
          between GMAT vs GRE, or unsure where to begin, our expert team will help you make confident, data-driven
          decisions.</p>
        <p>Share your details below and a Gradpilots expert will get in touch with you with a personalised plan not a
          generic pitch.</p>
      </div>
    </div>
    <div class="form_w">
      <form [formGroup]="contactForm" (ngSubmit)="submit()" validateOnSubmit>
        <ul>
          <li>
            <label for="">First Name <span>*</span></label>
            <input [ngClass]="{'ng-invalid ng-dirty': contactForm.get('firstName')?.invalid &&
            (submitted || contactForm.get('firstName')?.touched)}" type="text" formControlName="firstName"
              pInputText />
            <small class="text-red-500" *ngIf="contactForm.get('firstName')?.invalid &&
            (submitted || contactForm.get('firstName')?.touched)">
              First Name is required
            </small>
          </li>
          <li>
            <label for="">Last Name</label>
            <input formControlName="lastName" type="text" pInputText />
          </li>
          <li>
            <label for="">Email Address <span>*</span></label>
            <input [ngClass]="{'ng-invalid ng-dirty': contactForm.get('email')?.invalid &&
            (submitted || contactForm.get('email')?.touched)}" type="email" formControlName="email" pInputText />
            <small class="text-red-500" *ngIf="contactForm.get('email')?.invalid &&
            (submitted || contactForm.get('email')?.touched)">
              Email is required
            </small>
          </li>
          <li>
            <label for="">Phone Number <span>*</span></label>
            <input [ngClass]="{'ng-invalid ng-dirty': contactForm.get('phoneNumber')?.invalid &&
            (submitted || contactForm.get('phoneNumber')?.touched)}" type="text" formControlName="phoneNumber"
              pInputText />
            <small class="text-red-500" *ngIf="contactForm.get('phoneNumber')?.invalid &&
            (submitted || contactForm.get('phoneNumber')?.touched)">
              Phone Number is required
            </small>
          </li>
          <li class="full_col">
            <label for="">Message <span>*</span></label>
            <textarea [ngClass]="{'ng-invalid ng-dirty': contactForm.get('message')?.invalid &&
                     (submitted || contactForm.get('message')?.touched)}" rows="5" cols="30" pInputTextarea
              formControlName="message"></textarea>
            <small class="text-red-500" *ngIf="contactForm.get('message')?.invalid &&
            (submitted || contactForm.get('message')?.touched)">
              Message is required
            </small>
          </li>
          <li class="full_col">
            <p-button type="submit" label="Submit" (onClick)="submit()" [loading]="this.loading" styleClass="submitBtn"
              class="w-full sm:w-16rem h-3rem block bbtt" />
          </li>
        </ul>
      </form>
    </div>
  </div>
</div>

<div class="how_it_works_w">
  <div class="how_it_c">
    <h1>How It Works</h1>
    <div class="photo">
      <img src="assets/images/how_it_works_new.png" alt="How It Works">
      <img src="assets/images/how_it_works_mob_new.png" alt="How It Works Mobile" class="mobile">
    </div>
    <div class="all_btn">
      <a>All in One Service Recap</a>
    </div>
  </div>
</div>

<div class="pre_wrapper"
  style="background: url(assets/images/pre_bg.svg) no-repeat right top #fff; background-size: 35%;">
  <div class="preWrapper">
    <div class="heading">
      <small>Explore our Higher Education Consultancy Services</small>
      <h1>Pre-Admission Services</h1>
    </div>
    <ul>
      <li style="background-color: #F2F1FB;">Psychometric testing</li>
      <li style="background-color: #F2F1FB;">1:1 mentorship with expert counsellors</li>
      <li style="background-color: #F2F1FB;">Compare and shortlist colleges in
        India & Abroad</li>
      <li style="background-color: #F2F1FB;">AI-powered course shortlisting</li>
      <li style="background-color: #F2F1FB;">Schedule calls with peers in
        your dream school</li>
      <li style="background-color: #F2F1FB;">Shortlisting and applying
        for scholarships</li>
      <li style="background-color: #F2F1FB;">AI-powered profile-building
        recommendations</li>
      <li style="background-color: #F2F1FB;">Get live support to craft
        standout essays</li>
      <li style="background-color: #F2F1FB;">Comprehensive college application
        support, with GradPath</li>
    </ul>
  </div>
</div>

<div class="reach_usWrapper">
  <div class="reach_usWrapp_inner">
    <ul>
      <li>
        <div class="logo_social">
          <div class="logo">
            <img src="assets/images/logo.svg" alt="">
          </div>
          <p>Work with verified mentors with 20+ years of experience, who’ve successfully counselled students across
            India and major global universities.</p>
          <div class="social_links">
            <a href="https://www.facebook.com/share/1CScEL2upE/?mibextid=wwXIfr" target="_blank">
              <img src="assets/icons/facebook_icon.svg" alt="Facebook">
            </a>
            <a href="https://www.instagram.com/grad.pilots/" target="_blank">
              <img src="assets/icons/instagram_icon.svg" alt="Instagram">
            </a>
            <a href="https://www.linkedin.com/company/gradpilots/" target="_blank">
              <img src="assets/icons/linkedin_icon.svg" alt="LinkedIn">
            </a>
            <a href="https://www.youtube.com/@GradPilots" target="_blank">
              <img src="assets/icons/youtube_icon.svg" alt="YouTube">
            </a>
          </div>
        </div>
      </li>
      <li>
        <div class="reach_cc">
          <b>Reach Us</b>
          <div class="reach_links">
            <a href="tel:+919876996555"><img src="assets/icons/call_icon.svg" alt=""> +91 98769 96555</a>
            <a href="mailto:admin@gradpilots.com"><img src="assets/icons/email_icon.svg" alt=""> admin&#64;gradpilots.com</a>
            <a> House Number 3086, Sector 21D, Sector 21 (Chandigarh),
              Chandigarh, India, 160022</a>
          </div>
          <div class="photo">
            <img src="assets/images/reach_bg.svg" alt="">
          </div>
        </div>
      </li>
      <li>
        <div class="quick_links">
          <b>Quick Links</b>
          <div class="quick_links_inner">
            <a href="https://www.gradpilots.com/our-mission.html"><span></span> Our Mission</a>
            <a href="https://www.gradpilots.com/mentor-me.html"><span></span> Find a Mentor</a>
            <a href="https://www.gradpilots.com/all-services.html"><span></span> Services</a>
            <a href="https://www.gradpilots.com/study-in-india.html"><span></span> India Admissions</a>
            <a href="['/contact-us']"><span></span> Book a Free Counselling</a>
            <a [routerLink]="['/contact-us']"><span></span> Contact Us</a>
            <a href="https://www.gradpilots.com/student-success-stories.html"><span></span> Student Success Stories</a>
            <a href="https://blog.gradpilots.com/" target="_blank"><span></span> Resources / Blog</a>
          </div>
        </div>
      </li>
    </ul>
  </div>
</div>

<div class="faqs_wrapper">
  <div class="faqs_wrapper_inner">
    <h1>Frequently Asked <span>Questions</span></h1>
    <ul>
      <li *ngFor="let faq of faqs; let i = index">
        <h3 class="toggle-btn" [class.open]="activeIndex === i" (click)="toggleFaq(i)">{{ faq.question }}</h3>
        <div class="faqs" #faqContent [style.max-height]="activeIndex === i ? faqContent.scrollHeight + 'px' : '0px'">
          <p>{{ faq.answer }}</p>
        </div>
      </li>
    </ul>
  </div>
</div>